module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap1"
    }
  }, [_vm._v("FIRST")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“Just the place for a Snark!” the Bellman cried,")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("As he landed his crew with care;")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("Supporting each one on the top of the tide,")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("By a finger entwined in his hair.")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“Just the place for a Snark! I have said it twice: ")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("That alone should encourage the crew.")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("Just the place for a Snark! I have said it thrice: ")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("What I tell you three times is true.”")]), _vm._v(" "), _c('p', {
    staticClass: "epi",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('i', [_vm._v("—The Hunting of the Snark")])]), _vm._v(" "), _c('p', {
    staticClass: "epi2"
  }, [_vm._v("Fit the First")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbc1be4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/6chap1.vue
// module id = 75
// module chunks = 0